import React, { useState, useEffect, useCallback } from "react";
import { fetchUsersProfile } from "../../api/userProfile";
import { useNavigate } from "react-router-dom";
// import { PERPAGE_RECORD, showToast } from "../../utils/isValidImage";
import CustomPagination from "../../components/common/CustomPagination";

const PERPAGE_RECORD = 100;
const UsersProfile = () => {

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState(null); 
  


    const fetchUsers = useCallback(async (page = 1) => {
      setLoading(true);
      setError(null);
      try {
        // Optionally, you can pass a "type" parameter if needed, e.g., '?type=beast_mode'
        const { data, meta } = await fetchUsersProfile({page,limit:PERPAGE_RECORD});
        setUsers(data);

        data.pagination = {
          "currentPage": meta?.currentPage,
          "limit": meta?.limit,
          "totalRecords": meta?.total || 0,
          "totalPages": Math.ceil(meta?.total/meta?.limit)
      }
        setPagination(data.pagination);
      } catch (err) {
        console.error("Error fetching landing cards:", err);
        setError("Failed to fetch landing cards. Please try again later.");
      } finally {
        setLoading(false);
      }
    }, []);

 

  useEffect(() => {
    fetchUsers().then();
  }, [fetchUsers]);

  const handlePageChange = (page) => {
    fetchUsers(page).then();
  };

  // const { users, loading, error } = useFetchUsers();
  const navigate = useNavigate();

  const handleRowClick = (userId) => {
    navigate(`/user-detail/${userId}`);
  };
  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  if (error)
    return <div className="text-center text-danger mt-5">Error: {error}</div>;

  return (
    <div className="right-side-wrapper">
      <div className="container-fluid">
        <h2 className="text-center mb-4">Users List</h2>
        <div className="card shadow-sm rounded-3">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-primary">
                  <tr>
                    <th className="col-1">S.No</th>
                    <th className="col-2">Name</th>
                    <th className="col-2">Auth Provider</th>
                    <th className="col-3">Email</th>
                    <th className="col-3">Subscribe Status</th>
                    <th className="col-2">Is Active</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, index) => (
                    <tr
                      key={user.id}
                     
                      className={`${
                        index % 2 === 0 ? "bg-light" : "bg-offwhite"
                      }`}
                      style={{
                        cursor: "pointer",
                        transition: "background-color 0.3s ease",
                      }}
                    >
                      <td  onClick={() => handleRowClick(user.id)}>{index + 1}</td>
                      <td  onClick={() => handleRowClick(user.id)}>{user.name || "Unnamed User"}</td>
                      <td  onClick={() => handleRowClick(user.id)}>{user.authProvider || "N/A"}</td>
                      <td  onClick={() => handleRowClick(user.id)}>{user.email || "N/A"}</td> 
                      <td>

                      <div style={{ display: "flex", alignItems: "center", gap: "8px",  }}>
                        <span
                          className={`badge ${
                            user.subscribe_status === 'subscribed' ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {user.subscribe_status}
                        </span>
                        {/* <ReactSwitch 
                              onChange={() => toggleSubscriberStatus(user)}
                              checked={user.subscribe_status ==='subscribed'}
                              offColor="#ccc"
                              onColor="#4CAF50"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              height={20}
                              width={40}
                          /> */}
                                    </div>
                        
                        </td> 
                      <td>

                      {/* <ToogleField toggleStatus={toggleStatus} plan={{...user,status:user?.isOnline}} statusClass={user.isOnline ? "active-btn" : "inactive-btn"}  /> */}

                      <div style={{ display: "flex", alignItems: "center", gap: "8px",  }}>
                        <span
                          className={`badge ${
                            user.isOnline ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {user.isOnline ? "Yes" : "No"}
                        </span>
                        {/* <ReactSwitch 
                                        onChange={() => toggleStatus(user)}
                                        checked={user.isOnline}
                                        offColor="#ccc"
                                        onColor="#4CAF50"
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        height={20}
                                        width={40}
                                    /> */}
                                    </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
                      <CustomPagination pagination={pagination} handlePageChange={handlePageChange} />
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersProfile;
